enum MDVTypes {
  MEDICAL = 'Medical',
  DENTAL = 'Dental',
  VISION = 'Vision',
}

export default MDVTypes;
